// extracted by mini-css-extract-plugin
export var Icon = "styles-module--Icon--qITZr";
export var alignText = "styles-module--alignText--3CYe3";
export var menu = "styles-module--menu--7BtuR";